import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Modal } from '../../../../components';
import { deleteUsers } from '../../../../store/users/users.actions';
import { Row, User } from '../../../../types';

type DeleteUserModalProps = {
  users: User[] | Row[];
  onClose: () => void;
  orgId: string;
  open: boolean;
};

export const DeleteUserModal: React.FC<DeleteUserModalProps> = ({
  users,
  onClose,
  orgId,
  open,
}: DeleteUserModalProps): JSX.Element => {
  const [deleted, setDeleted] = useState(false);
  const dispatch = useDispatch();

  const usersToDelete = users.map((user: Row | User) => user.name);
  const userIds = users.map((user: Row | User) => user.userId);

  const handleDelete = () => {
    setDeleted(true);
  };

  const handleClose = () => {
    dispatch(deleteUsers(userIds, orgId));
  };

  useEffect(() => {
    if (!open) setDeleted(false);
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={deleted ? handleClose : onClose}
      title="Delete member"
    >
      <div className="delete-user-modal">
        {deleted ? (
          <>
            <span className="delete-user-modal__users">
              {usersToDelete.join(', ')}
            </span>{' '}
            {usersToDelete.length === 1 ? ' was ' : ' were '}
            <span className="delete-user-modal__users">deleted</span>
            <Button
              onClick={onClose}
              variant="common"
              className="delete-user-modal__btn"
            >
              Undo
            </Button>
          </>
        ) : (
          <>
            Are you sure you want to delete{' '}
            <span className="delete-user-modal__users">
              {usersToDelete.join(', ')}?
            </span>
            <Button
              className="delete-user-modal__btn"
              onClick={onClose}
              variant="common"
            >
              Got it
            </Button>
            <Button
              onClick={handleDelete}
              className="delete-user-modal__btn"
              variant="text"
            >
              Cancel
            </Button>
          </>
        )}
      </div>
    </Modal>
  );
};
